import { api } from "@/lib/api";
import type { Env, LogsResponse } from "@/lib/types";
import { keepPreviousData, useQuery } from "@tanstack/react-query";

interface LogsParams {
  level?: string;
  source?: string;
  q?: string;
  after?: string;
  before?: string;
  limit?: number;
  env?: Env;
}

export function useLogs(params: LogsParams = {}) {
  const searchParams = new URLSearchParams();
  if (params.level) searchParams.set("level", params.level);
  if (params.source) searchParams.set("source", params.source);
  if (params.q) searchParams.set("q", params.q);
  if (params.after) searchParams.set("after", params.after);
  if (params.before) searchParams.set("before", params.before);
  if (params.limit) searchParams.set("limit", String(params.limit));
  if (params.env) searchParams.set("env", params.env);

  const qs = searchParams.toString();
  const path = `/api/ops/v1/logs${qs ? `?${qs}` : ""}`;

  return useQuery({
    queryKey: ["logs", params],
    queryFn: () => api<LogsResponse>(path),
    placeholderData: keepPreviousData,
    refetchInterval: 30_000,
  });
}
